import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { kpis } from '../data/dashboardData';
export function KpiRow() {
  return <section aria-labelledby="portfolio-performance" data-id="element-69">
      <div className="mb-3 flex items-end justify-between" data-id="element-70">
        <h2 id="portfolio-performance" className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#53616a]" data-id="element-71">
          Portfolio performance
        </h2>
        <p className="hidden text-[11px] text-[#858178] sm:block" data-id="element-72">
          On-the-books · Next 30 days
        </p>
      </div>
      <div className="grid grid-cols-2 border border-[#d8d2c6] bg-[#fffcf7] lg:grid-cols-4" data-id="element-73">
        {kpis.map((item, index) => <motion.article key={item.label} initial={{
        opacity: 0,
        y: 7
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        delay: index * 0.06
      }} className={`p-4 sm:p-5 ${index % 2 ? '' : 'border-r border-[#ded8cc]'} ${index < 2 ? 'border-b border-[#ded8cc] lg:border-b-0' : ''} ${index === 1 ? 'lg:border-r' : ''} ${index === 2 ? 'lg:border-r' : ''}`} data-id="element-74">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#74766f]" data-id="element-75">
              {item.label}
            </p>
            <div className="mt-3 flex items-end justify-between gap-2" data-id="element-76">
              <p className="font-serif text-2xl text-[#0b2032] sm:text-[29px]" data-id="element-77">
                {item.value}
              </p>
              <span className="mb-1 flex items-center text-[11px] font-semibold text-[#34705c]" data-id="element-78">
                <ArrowUpRightIcon size={12} data-id="element-79" /> {item.change}
              </span>
            </div>
            <p className="mt-1 text-[10px] text-[#8a887f]" data-id="element-80">{item.note}</p>
          </motion.article>)}
      </div>
    </section>;
}